import React, { useRef, useState, useEffect } from "react";
import PPostComment from "../PPostComment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import SendTipModal from "../PSendTipModal";
import PThankYou from "../PThankYou";
import useDidMountEffect from "../../utils/useDidMountEffect";
import PVerificationModal from "../PVerificationModal";
import { connect, useDispatch, useSelector } from "react-redux";
import {
    setCreditCardForm,
    setDarkmode,
    updateCcVerification,
} from "../../../redux/actions";
import { CARD_ERRORS, POST_TYPE, ROLES } from "../../utils/constants";
import ReportPost from "../ReportPost";
import Toast from "react-bootstrap/Toast";
import DecimalInput from "../DecimalInput";
import styled from "styled-components";
import { moneyFormat, totalCount } from "../../utils/helper";
import PostStatistics from "./post-statistics";
import currency from "currency.js";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { CircularProgress } from "@mui/material";
import {
    setTipNextAction,
    setTipPostId,
    toggleTip,
} from "../../../redux/actions/privaGlobal";

const SpanPpv = styled.span`
    padding-left: 15px;
    font-weight: bold;
    font-size: 14px;
    display: flex;
    align-items: center;
    height: 20px;
    padding-left: 15px;
    font-weight: bold;
    font-size: 14px;
    display: flex;
    align-items: center;
    height: 20px;

    @media (max-width: 767px) {
        padding-left: 8px;
    }
`;

const SpanDesktopOnly = styled.span`
    display: none;

    @media (min-width: 768px) {
        display: inline-flex;
        align-items: center;
        height: 20px;
    }
`;

const Reactions = ({ post, comment, setComment, user, darkmode }) => {
    const [likes, setLikes] = useState(post.likes ?? []);
    const [isLiked, setIsLiked] = useState(post.is_liked_by_user);
    const [thankYou, setThankyou] = useState(false);
    const [checkingValidity, setCheckingValidity] = useState(false);

    const dispatch = useDispatch();
    const userInformation = JSON.parse(localStorage.getItem("user"));

    const tipRdx = useSelector((state) => state.privaGlobal.tipForm);
    const showCcVerification = useSelector(
        (state) => state.ccVerification.showVerify
    );
    const creditCardFormShow = useSelector(
        (state) => state.privaGlobal.creditCardForm.show
    );

    const handleLike = async () => {
        await axios.post(`/api/posts/${post.id}/likes`).then((response) => {
            const userIndex = likes.findIndex(
                (like) => like.user_id === userInformation.id
            );

            if (userIndex >= 0) {
                likes.splice(userIndex, 1);
            } else {
                likes.push({
                    user_id: userInformation.id,
                });
            }

            setLikes(likes);
            setIsLiked(!isLiked);
        });
    };

    const [showModal, setShowModal] = useState(false);
    const [tipSuccess, setTipSuccess] = useState(false);
    const [showVerification, setShowVerification] = useState(false);
    const [canSendTip, setCanSendTip] = useState(false);

    const checkCardStatus = async () => {
        setCheckingValidity(true);
        await axios
            .get("/api/cards/should-verify")
            .then((response) => {
                setCheckingValidity(false);
                setCanSendTip(true);
            })
            .catch((error) => {
                setCheckingValidity(false);

                if (error && error.response) {
                    if (error.response.status === 402) {
                        if (
                            error.response.data.error ===
                            CARD_ERRORS.NEEDS_VALIDATION
                        ) {
                            dispatch(
                                updateCcVerification({
                                    showVerify: true,
                                })
                            );
                            return;
                        }

                        if (error.response.data.error === CARD_ERRORS.NO_CARD) {
                            dispatch(
                                setCreditCardForm({
                                    show: true,
                                    prefilled: true,
                                    closeOnly: true,
                                    intent: "Send Tip",
                                    nextAction: "TIP",
                                })
                            );
                            return;
                        }
                    }
                }
            });
    };

    const handleModal = () => {
        dispatch(setTipPostId(post.id));
        setShowModal(true);
        // checkCardStatus();
    };

    useEffect(() => {
        if (canSendTip) {
            setShowModal(true);
        }
    }, [canSendTip]);

    useDidMountEffect(() => {
        if (!showModal) {
            setCanSendTip(false);
        }
    }, [showModal]);

    useEffect(() => {
        if (tipSuccess) {
            setShowModal(false);
            setThankyou(true);
            setTipSuccess(false);
        }
    }, [tipSuccess]);

    useEffect(() => {
        if (!showModal) {
            document.body.style.overflow = "auto";
        }
    }, [showModal]);

    useDidMountEffect(() => {
        if (!thankYou) {
            setShowModal(false);
            document.body.style.overflow = "auto";
        }
    }, [thankYou]);

    const ref = useRef(null);
    const [showOverlay, setShowOverlay] = useState(false);
    const [numLikes, setNumLikes] = useState("");
    const [numLikesBusy, setNumLikesBusy] = useState(false);

    const handleAddLikes = (event) => {
        setShowOverlay(!showOverlay);
    };

    const handleChangeLikesInput = (value) => {
        setNumLikes(value);
    };

    const handleSaveLikes = async () => {
        setNumLikesBusy(true);
        await axios
            .post(`/api/posts/${post.id}/add-likes`, {
                num_likes: numLikes,
            })
            .then((response) => {
                let payload = [];
                for (let n = 0; n < numLikes; n++) {
                    payload.push({
                        post_id: post.id,
                        user_id: post.pu_id,
                    });
                }

                setLikes(likes.concat(payload));

                setNumLikesBusy(false);
                setNumLikes("");
                setShowOverlay(false);
            })
            .catch((error) => {
                setNumLikesBusy(false);
                captureMessage(error);
            });
    };

    const handleTipForm = (value) => {
        setShowModal(value);
        dispatch(toggleTip(value));

        if (!value) {
            dispatch(setTipPostId(""));
            dispatch(setTipNextAction(""));
        }
    };

    useDidMountEffect(() => {
        if (!thankYou) {
            dispatch(setTipPostId(""));
            dispatch(setTipNextAction(""));
            dispatch(toggleTip(false));
        }
    }, [thankYou]);

    return (
        <>
            {thankYou && (
                <PThankYou show={thankYou} pu={user} setShow={setThankyou} />
            )}
            {showVerification && (
                <PVerificationModal
                    show={showVerification}
                    setShowVerification={setShowVerification}
                />
            )}
            {((showModal && !showCcVerification && !creditCardFormShow) ||
                (tipRdx.show && tipRdx.postId == post.id)) && (
                <SendTipModal
                    user={user}
                    setShowModal={handleTipForm}
                    show={showModal || tipRdx.show}
                    setTipSuccess={setTipSuccess}
                    setShowVerification={setShowVerification}
                    post={post}
                />
            )}
            <div className="posts-list-item-footer-btns">
                {user &&
                    Object.keys(user).length > 0 &&
                    ![178601, 292].includes(user.id) && (
                        <>
                            <a onClick={handleLike}>
                                <FontAwesomeIcon
                                    icon={
                                        isLiked
                                            ? ["fas", "heart"]
                                            : ["far", "heart"]
                                    }
                                    color={isLiked ? "#DA005E" : ""}
                                />{" "}
                                <strong>{totalCount(likes.length)}</strong>
                            </a>
                            <a onClick={() => setComment(!comment)}>
                                <FontAwesomeIcon icon={["far", "comment"]} />{" "}
                                <strong>
                                    {totalCount(post.comments_count)}
                                </strong>
                            </a>
                        </>
                    )}
                {userInformation && post.pu_id != userInformation.id && (
                    <a
                        onClick={handleModal}
                        className={`post__sendtip${
                            checkingValidity ? " disabled" : ""
                        }`}
                    >
                        <i className="fa-regular fa-circle-dollar"></i>{" "}
                        {checkingValidity ? (
                            <CircularProgress size={18} />
                        ) : (
                            "SEND TIP"
                        )}
                    </a>
                )}

                {userInformation && post.pu_id == userInformation.id && (
                    <SpanPpv
                        style={
                            ![178601, 292].includes(user.id)
                                ? {}
                                : { paddingLeft: 0 }
                        }
                    >
                        Tips {moneyFormat(post.tips_sum_pu_total ?? 0)}
                    </SpanPpv>
                )}

                {userInformation &&
                    post.pu_id == userInformation.id &&
                    post.price > 0 && (
                        <SpanPpv>
                            PPV
                            <SpanDesktopOnly
                                className={"post-gallery-footer-hidden-text"}
                            >
                                {" "}
                                &nbsp;Purchases&nbsp;
                            </SpanDesktopOnly>{" "}
                            {moneyFormat(post.transactions_sum_pu_total)}
                        </SpanPpv>
                    )}

                {userInformation &&
                    [ROLES.ADMIN].includes(userInformation.role) && (
                        <div
                            ref={ref}
                            style={{ paddingLeft: "10px", marginTop: "-2px" }}
                        >
                            <i
                                style={{ cursor: "pointer" }}
                                className="fa-regular fa-lg fa-heart-circle-plus"
                                onClick={handleAddLikes}
                            ></i>
                        </div>
                    )}
                {showOverlay && (
                    <div className="add-likes-container">
                        <Toast
                            show={showOverlay}
                            onClose={() => setShowOverlay(!showOverlay)}
                            className="add-likes__container"
                        >
                            <Toast.Header>
                                <strong className="me-auto">
                                    Add more likes
                                </strong>
                            </Toast.Header>
                            <Toast.Body>
                                <div className="add-likes__form">
                                    <DecimalInput
                                        inputMode="number"
                                        className="input-sm"
                                        handleChange={handleChangeLikesInput}
                                        value={numLikes}
                                        disabled={numLikesBusy}
                                    />
                                    <button
                                        className="btn btn-xs btn-primary btn-rounded"
                                        onClick={handleSaveLikes}
                                        disabled={numLikesBusy}
                                    >
                                        Add
                                    </button>
                                </div>
                            </Toast.Body>
                        </Toast>
                    </div>
                )}
            </div>
        </>
    );
};

const PostFooter = ({ post, comment, user, darkmode }) => {
    const [currentPost, setCurrentPost] = useState(post);
    const [showComment, setShowComment] = useState(comment);
    const [showStatistics, setShowStatistics] = useState(false);

    const userInformation = JSON.parse(localStorage.getItem("user"));

    const setCommentCount = (value) => {
        setCurrentPost({
            ...currentPost,
            comments_count: currentPost.comments_count + value,
        });
    };

    const [showReportModal, setShowReportModal] = useState(false);
    const handleReportPost = () => {
        setShowReportModal(true);
    };

    const toggleStatistics = (e) => {
        e.preventDefault();
        setShowStatistics((showStatistics) => !showStatistics);
    };

    return (
        <>
            <div className="posts-list-item-footer">
                {user && Object.keys(user).length > 0 && (
                    <Reactions
                        post={currentPost}
                        comment={showComment}
                        setComment={setShowComment}
                        user={user}
                        darkmode={darkmode}
                    />
                )}

                {userInformation &&
                    [ROLES.PU].includes(userInformation.role) &&
                    userInformation.id == currentPost.pu_id && (
                        <div className="posts-list-item-footer-dots post-footer-statistics">
                            {userInformation &&
                                currentPost.pu_id == userInformation.id &&
                                currentPost.price > 0 && (
                                    <SpanPpv style={{ float: "right" }}>
                                        <a onClick={toggleStatistics}>
                                            <SpanDesktopOnly
                                                className={
                                                    "post-gallery-footer-hidden-text"
                                                }
                                            >
                                                Post&nbsp;Statistics &nbsp;
                                            </SpanDesktopOnly>{" "}
                                            <i
                                                className="fa-regular fa-square-poll-horizontal"
                                                style={{ fontSize: 20 }}
                                            ></i>
                                        </a>
                                    </SpanPpv>
                                )}

                            {showStatistics && (
                                <PostStatistics
                                    post={currentPost}
                                    show={showStatistics}
                                    setShow={setShowStatistics}
                                />
                            )}
                        </div>
                    )}

                {post.user_tip_total && post.user_tip_total > 0 ? (
                    <div
                        css={css`
                            font-weight: bolder;
                        `}
                    >
                        Your Tip:{" "}
                        {currency(post.user_tip_total).format({
                            precision: 2,
                        })}
                    </div>
                ) : null}
            </div>
            {showComment && (
                <PPostComment
                    post={currentPost}
                    showComment={showComment}
                    setShowComment={setShowComment}
                    setCurrentPost={setCurrentPost}
                    setCommentCount={setCommentCount}
                    user={user}
                />
            )}

            {showReportModal && (
                <ReportPost
                    show={showReportModal}
                    setShow={setShowReportModal}
                    post={currentPost}
                />
            )}
        </>
    );
};

function mapStateToProps(state) {
    return {
        darkmode: state.privaGlobal.darkmode,
        activePost: state.privaGlobal.selectedPost,
        action: state.post.action,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setDarkmode: (payload) => dispatch(setDarkmode(payload)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PostFooter);
